import { combineReducers } from "redux";
import topGainersLosers from "./topGainersLosers";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer from "../common/params";
export default combineReducers({
    reducersData: topGainersLosers,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
